import metricLabels from "./metricLabels/metricLabels";
import { extraMetrics } from "./constants";

export const FiltersHelpTexts = transformToMile => {
  const columnLabels = {
    ...extraMetrics,
    ...metricLabels({ transformToMile, withUnits: true })
  };

  const textMaker = type => `What are ${type} metrics?`;

  return {
    shortText: "Read more",
    flight: {
      text: textMaker(columnLabels.flightGroup),
      url: "https://help.cirrus.ai/en/articles/4529279-flight-metrics"
    },
    loadFactorGroup: {
      text: textMaker(columnLabels.loadFactorGroup),
      url: "https://help.cirrus.ai/en/articles/4306360-load-factor-metrics"
    },
    finalLoadFactorGroup: {
      text: textMaker(columnLabels.finalLoadFactorGroup),
      url: "https://help.cirrus.ai/en/articles/4306360-load-factor-metrics"
    },
    raskGroup: {
      text: textMaker(columnLabels.raskGroup),
      url: "https://help.cirrus.ai/en/articles/4284614-revenue-metrics"
    },
    revenueGroup: {
      text: textMaker(columnLabels.revenueGroup),
      url: "https://help.cirrus.ai/en/articles/4284614-revenue-metrics"
    },
    finalRaskGroup: {
      text: textMaker(columnLabels.finalRaskGroup),
      url: "https://help.cirrus.ai/en/articles/4284614-revenue-metrics"
    },
    finalRevenueGroup: {
      text: textMaker(columnLabels.finalRevenueGroup),
      url: "https://help.cirrus.ai/en/articles/4284614-revenue-metrics"
    },
    finalRevenuePerBookingGroup: {
      text: textMaker(columnLabels.finalRevenuePerBookingGroup),
      url: "https://help.cirrus.ai/en/articles/4657898-revenue-per-booking-metrics"
    },
    revenuePerBookingGroup: {
      text: textMaker(columnLabels.revenuePerBookingGroup),
      url: "https://help.cirrus.ai/en/articles/4657898-revenue-per-booking-metrics"
    },
    yieldGroup: {
      text: textMaker(columnLabels.yieldGroup),
      url: "https://help.cirrus.ai/en/articles/4284641-yield-metrics"
    },
    finalYieldGroup: {
      text: textMaker(columnLabels.finalYieldGroup),
      url: "https://help.cirrus.ai/en/articles/4284641-yield-metrics"
    },
    sellingFareGroup: {
      text: textMaker(columnLabels.sellingFareGroup),
      url: "https://help.cirrus.ai/en/articles/4306361-pricing-metrics"
    },
    pricePercentileGroup: {
      text: textMaker(columnLabels.pricePercentileGroup),
      url: "https://help.cirrus.ai/en/articles/4306361-pricing-metrics"
    },
    lacGroup: {
      text: textMaker(columnLabels.lacGroup),
      url: "https://help.cirrus.ai/en/articles/4306361-pricing-metrics"
    },
    influenceGroup: {
      text: textMaker(columnLabels.influenceGroup),
      url: "https://help.cirrus.ai/en/articles/4306363-analyst-metrics"
    },
    capacityGroup: {
      text: textMaker(columnLabels.capacityGroup),
      url: "https://help.cirrus.ai/en/articles/4284640-capacity-metrics"
    },
    bookingsGroup: {
      text: textMaker(columnLabels.bookingsGroup),
      url: "https://help.cirrus.ai/en/articles/4306359-booking-metrics"
    },
    lacSeatsAvailableGroup: {
      text: textMaker(columnLabels.lacSeatsAvailableGroup),
      url: "https://help.cirrus.ai/en/articles/4306361-pricing-metrics"
    },
    competitorFareGroup: {
      text: textMaker(columnLabels.competitorFareGroup),
      url: "https://help.cirrus.ai/en/articles/4284643-competitor-fare-metrics"
    }
  };
};
